import { render, staticRenderFns } from "./ShortStats.vue?vue&type=template&id=62c2d0b7&"
import script from "./ShortStats.vue?vue&type=script&lang=js&"
export * from "./ShortStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports